import { IApplicationData } from 'core-components/sitebuilder/models/IApplication'
import settings from 'src/config/settings'

export const getAppOwnerId = () => {
  return getApp().ownerId
}

export const getAppId = () => {
  return getApp().id
}

export const isSubApplication = () => {
  // @ts-ignore MF
  return settings.isSubApplication
}

export const initGlobalApplicationData = (data: IApplicationData) => {
  if (!isSubApplication()) {
    // @ts-ignore MF
    window.__core_app_data = data
  }
}

const getApp = () => {
  if (isSubApplication()) {
    // @ts-ignore MF
    return window.__core_app_data || settings.appIdentifier
  }
  return settings.appIdentifier
}
